import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { formatServiceDateShort } from "../../../utils/dateUtils";

export default function ServicioList({ items, selectedId, onSelect, emitidos }) {
  if (!items.length) {
    return (
      <Box sx={{ py: 6, textAlign: "center" }}>
        <Typography sx={{ fontSize: 14, color: "#9ca3af" }}>
          {emitidos
            ? "No hay certificados emitidos en este mes."
            : "No hay servicios con reporte de plagas pendientes de certificado."}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {items.map((item) => {
        const id = emitidos ? item.folio : item.pestReportId;
        const selected = selectedId === id;

        return (
          <Box
            key={id}
            onClick={() => onSelect(item)}
            sx={{
              p: 1.75,
              borderRadius: "12px",
              border: selected ? "1.5px solid #1975d1" : "1px solid #e8eaef",
              bgcolor: selected ? "#f4f8fd" : "#fff",
              cursor: "pointer",
              transition: "border-color 0.15s, background 0.15s",
              "&:hover": {
                borderColor: selected ? "#1975d1" : "#c7d7ea",
                bgcolor: selected ? "#f4f8fd" : "#fafbfc",
              },
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1, mb: 0.5 }}>
              <Typography sx={{ fontSize: 13.5, fontWeight: 650, color: "#111827", lineHeight: 1.3 }}>
                {item.cliente}
              </Typography>
              {emitidos ? (
                <Chip
                  label="Emitido"
                  size="small"
                  sx={{
                    height: 22,
                    fontSize: 11,
                    fontWeight: 600,
                    bgcolor: "#ecfdf5",
                    color: "#059669",
                  }}
                />
              ) : (
                <Chip
                  label={item.typeLabel || item.type}
                  size="small"
                  sx={{
                    height: 22,
                    fontSize: 11,
                    fontWeight: 600,
                    bgcolor: "#eef5fd",
                    color: "#1975d1",
                  }}
                />
              )}
            </Box>
            <Typography sx={{ fontSize: 12, color: "#6b7280", lineHeight: 1.4 }}>
              {item.lugar}
            </Typography>
            <Typography sx={{ mt: 0.5, fontSize: 11.5, color: "#9ca3af" }}>
              {emitidos
                ? `${item.fecha} · ${item.folio}`
                : `${formatServiceDateShort(item.date)}${item.hour ? ` · ${item.hour}` : ""} · ${item.tecnico?.nombre || "Sin técnico"}`}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
